import crypto from "crypto-js";

export class SecureStorage {
    constructor() {
        this.secretKey = this.getOrCreateSecretKey();
    }

    setItem(key, value) {
        try {
            this.persistSecretKey();
            const encryptedValue = crypto.AES.encrypt(value, this.secretKey).toString();
            localStorage.setItem(key, encryptedValue);
        } catch (error) {
            console.error("Failed to encrypt value: ", error);
        }
    }

    getItem(key) {
        try {
            const encryptedValue = localStorage.getItem(key);
            if (!encryptedValue) return null;

            const value = crypto.AES.decrypt(encryptedValue, this.secretKey);
            return value.toString(crypto.enc.Utf8);
        } catch {
            this.clearItem(key);
            return null;
        }
    }

    clearItem(key) {
        localStorage.removeItem(key);
    }

    getOrCreateSecretKey() {
        // Migrate the existing tab key before it disappears on a PWA restart.
        let key = localStorage.getItem('secret_key') || sessionStorage.getItem('secret_key');
        if (!key) {
            key = crypto.lib.WordArray.random(32).toString();
        }
        localStorage.setItem('secret_key', key);
        sessionStorage.setItem('secret_key', key);
        return key;
    }

    persistSecretKey() {
        // Logout clears storage, but this module instance survives until reload.
        localStorage.setItem('secret_key', this.secretKey);
        sessionStorage.setItem('secret_key', this.secretKey);
    }

    encrypt(value) {
        try {
            this.persistSecretKey();
            const encryptedValue = crypto.AES.encrypt(value, this.secretKey).toString();
            return encryptedValue;
        } catch (error) {
            console.error("Value encryption failed: ", error);
            return null;
        }
    }

    decrypt(encryptedValue) {
        try {
            const value = crypto.AES.decrypt(encryptedValue, this.secretKey);
            return value.toString(crypto.enc.Utf8);
        } catch {
            return null;
        }
    }
}

export const cryptoStorage = new SecureStorage();
